import { useAuth } from '@features/auth/context/AuthContext';
import { useState } from 'react';
import { useOnboarding } from './useOnboarding';

/**
 * Hook to check onboarding progress and redirect to the appropriate step
 * @returns Loading state and checkOnboardingProgress function
 */
export const useOnboardingRedirect = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { isAuthenticated } = useAuth();

  // Get the initializeOnboarding function from useOnboarding at the hook level
  const { initializeOnboarding } = useOnboarding();

  /**
   * Checks onboarding progress and redirects to the appropriate step
   * Uses the initializeOnboarding function from useOnboarding hook
   */
  const checkOnboardingProgress = async () => {
    // If the user is not authenticated, do nothing
    if (!isAuthenticated) {
      return;
    }

    try {
      setLoading(true);
      setError(null);

      // Call the initializeOnboarding function that was obtained at the hook level
      await initializeOnboarding();
    } catch (error) {
      console.error('Error checking onboarding progress:', error);
      setError('Failed to check onboarding progress. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    checkOnboardingProgress
  };
};
